import { UiSchemaStateModel } from "../models/ui-schema-state";

export class UpdateState {
  public static readonly type = "[Ui Schema State] Update State";
  constructor(public state: Partial<UiSchemaStateModel>) {}
}
